var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mpg-box"},[_c('h1',{staticClass:"mb-0"},[_vm._v("پرداخت یکپارچه")]),_c('list-of-cards')],1),_c('bank-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }